export default {
    price: 1000,
    light: {
        primary: '#19D2D2',
        secondary: '#424242',
        accent: '#82FFFF',
    },
    dark: {
        primary: '#19D2D2',
        secondary: '#424242',
        accent: '#82FFFF',
    }
}
